import { css } from '@emotion/core';

import { SPACE_COMFORTABLE, SPACE_COMPACT, card, flexSpace, spaceTopComfortable } from '@/styles';

export const search = css``;

export const sectionTopStyles = [
  flexSpace,
  css`
    padding: 0 ${SPACE_COMPACT}px;
    flex-wrap: nowrap;
  `,
];

export const sectionMainStyles = [
  css`
    display: grid;
    grid-gap: 1em;
    padding: 0 ${SPACE_COMPACT}px;
  `,
  spaceTopComfortable,
];

export const contentDashboardStyles = css`
  padding: ${SPACE_COMFORTABLE}px;
  ${card};
`;
